import axios from "axios";

export const state = {
    requirementdetails: [],
};

export const getters = {
    requirementdetails: state => state.requirementdetails,
};

export const mutations = {
    setRequirementdetails(state, newValue) {
        state.requirementdetails = newValue
    },
};

export const actions = {
    fetchRequirementdetails({ commit }) {
        axios.get('/schoolrequirementdetails').then(res => {
            commit('setRequirementdetails', res.data.carts)

        })
    },
    filterRequirementdetails({commit}, {schoolterm,year,schoolclass}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("schoolclass", schoolclass);
        let url = "/filterrequirementdetails";
        axios.post(url, formData).then((response) => {
            commit('setRequirementdetails', response.data.details)
        })
    },
};
